/**
 * Hooks up controls for the header menu
 */
export const headerMenu = (): void => {
  const bodyElement = document.querySelector('body') as unknown as HTMLElement

  const headerMenu = document.querySelector('.js-headerMenu') as unknown as HTMLElement

  const summonElement = document.querySelector('.js-headerController') as unknown as HTMLElement

  const allSubMenus = document.querySelectorAll('.js-headerMenuItem.-hasCarret') as unknown as HTMLElement[]

  summonElement.addEventListener('click', () => {
    bodyElement.classList.add('menuPopupPhone--opened')
  })

  document.addEventListener('click', (e) => {
    const triggerElement = e.target as unknown as HTMLElement
    const menuElement = triggerElement.closest('.js-headerMenu')

    if (!triggerElement.classList.contains('js-headerMenu') && !menuElement && summonElement !== triggerElement) {
      bodyElement.classList.remove('menuPopupPhone--opened')
    }
  })

  const hookMobileControls = () => {
    headerMenu.addEventListener('swiped-right', function (e: any) {
      const startX: number = e.detail.xStart
      const endX: number = e.detail.xEnd

      if (startX - endX <= -50) {
        bodyElement.classList.remove('menuPopupPhone--opened')
      }
    })
  }

  hookMobileControls()

  if (allSubMenus) {
    allSubMenus.forEach(subMenu => {
      const carretElement = subMenu.querySelector('.js-headerMenuCarret') as unknown as HTMLElement

      carretElement.addEventListener('click', () => {
        if (subMenu.classList.contains('submenu--opened')) {
          subMenu.classList.remove('submenu--opened')
        } else {
          subMenu.classList.add('submenu--opened')
        }
      })
    })
  }
}
